import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import InviteFriendFlag from 'Components/InviteFriendFlag';

const InviteFriend = loadable(() => pMinDelay(import('./InviteFriend'), 300), {
  fallback: <Loading />,
});

const AsyncInviteFriend = props => {
  const metaConfiguration = props.metaConfiguration['/arkadasini-getir'];
  const title = metaConfiguration?.title;
  const description = metaConfiguration.description;

  const pageConfig = {
    headerType: 'mobile-none',
    footerType:
      props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${props.userAgent.device?.type} hide-betslip hide-sticky-navigation`,
      },
      title,
      description,
    },
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <InviteFriendFlag>
        <InviteFriend { ...props } />
      </InviteFriendFlag>
    </ApplicationLayout>
  );
};

AsyncInviteFriend.propTypes = {
  userAgent: PropTypes.object,
  metaConfiguration: PropTypes.object
};

export default AsyncInviteFriend;
